import { Link } from '@inertiajs/react'
import { Section } from '@/components/design-system/Section'
import { statusBadge, formatDate } from '@/frontend/pages/CommandCenter/Telemetry/utils'

interface RecentWorker {
  id: string
  name: string
  organizationName: string
  provisioningStatus: string
  createdAt: string
}

interface Props {
  data: {
    byStatus: Record<string, number>
    byProfile: Record<string, number>
    recentWorkers: RecentWorker[]
  }
}

const profileLabels: Record<string, string> = {
  'generalist': 'Generalista',
  'ecommerce-marketing': 'E-commerce Marketing',
  'customer-success': 'Customer Success',
}

export default function FleetOverviewSection({ data }: Props) {
  return (
    <Section title="Visão da Frota">
      <div className="space-y-4">
        {/* Provisioning status */}
        <div>
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Status de Provisionamento</p>
          <div className="flex flex-wrap gap-2">
            {['ready', 'pending', 'provisioning', 'failed'].map((status) => (
              <Link key={status} href={`/cc/digital_workers?provisioning_status=${status}`}>
                <span className="inline-flex items-center gap-1.5">
                  {statusBadge(status)}
                  <span className="text-sm font-medium text-foreground">{data.byStatus[status] || 0}</span>
                </span>
              </Link>
            ))}
          </div>
        </div>

        {/* Profile breakdown */}
        <div>
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Por Perfil</p>
          <div className="flex flex-wrap gap-3">
            {Object.entries(data.byProfile).map(([profile, count]) => (
              <span key={profile} className="text-sm text-foreground">
                <span className="text-muted-foreground">{profileLabels[profile] || profile}:</span>{' '}
                <span className="font-medium">{count}</span>
              </span>
            ))}
          </div>
        </div>

        {/* Recent workers */}
        <div>
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">Recentes</p>
          <div className="space-y-2">
            {data.recentWorkers.map((w) => (
              <Link key={w.id} href={`/cc/digital_workers/${w.id}`} className="flex items-center justify-between py-1.5 hover:bg-accent rounded px-2 -mx-2 transition-colors">
                <div className="flex items-center gap-2 min-w-0">
                  <span className="text-sm font-medium text-foreground truncate">{w.name}</span>
                  <span className="text-xs text-muted-foreground truncate">{w.organizationName}</span>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  {statusBadge(w.provisioningStatus)}
                  <span className="text-xs text-muted-foreground">{formatDate(w.createdAt)}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}
